import { debugManager } from '@tunein/web-utils';
export const debug = debugManager.createDebugger('OS', 'Oustream Video Ad Player');
export function createOutstreamVideoAdMediaElementId(containerId) {
    return `${containerId}-media`;
}
export function createOutstreamVideoAdHouseAdsMediaElementId(containerId) {
    return `${containerId}-house-ads`;
}
export function isVideoAdEvent(event) {
    return Boolean(event.contentType?.includes('video') || (event.width && event.height));
}
export function isJavaScriptAdEvent(event) {
    return Boolean(event?.contentType?.includes('javascript'));
}
